module.exports = __webpack_public_path__ + "img/trash.d5f86883.svg";